const state = {
  disbursementDate: null,
  firstCreditDate: null,
  ppsCurrentAppId: null,
  ppsLatestAppId: null,
  ppsNextAdvanceNumber: null,
  ppsSinglePSActionInterest: null,
  ppsLatestSlaveLoan: null,
  ppsFirstValidSlaveLoan: null,
  ppsFirstValidSlaveLoanId: null,
  loanHistoryData: null,
  sendEmailLoanID: null
}

// getters
const getters = {
  getDisbursementDate: (state) => {
    return state.disbursementDate
  },
  getFirstCreditDate: (state) => {
    return state.firstCreditDate
  },
  getPPSCurrentAppId: (state) => {
    return state.ppsCurrentAppId
  },
  getPPSLatestAppId: (state) => {
    return state.ppsLatestAppId
  },
  getPPSNextAdvanceNumber (state) {
    return state.ppsNextAdvanceNumber
  },
  getPPSSinglePSActionInterest: (state) => {
    return state.ppsSinglePSActionInterest
  },
  getPPSLatestSlaveLoan: (state) => {
    return state.ppsLatestSlaveLoan
  },
  getPPSFirstValidSlaveLoan: (state) => {
    return state.ppsFirstValidSlaveLoan
  },
  getPPSFirstValidSlaveLoanId: (state) => {
    return state.ppsFirstValidSlaveLoanId
  },
  getLoanHistoryData: (state) => {
    return state.loanHistoryData
  },
  getSendEmailLoanId: (state) => {
    return state.sendEmailLoanID
  }
}

// actions
const actions = {}

// mutations
const mutations = {
  setDisbursementDate (state, payload) {
    state.disbursementDate = payload
  },
  setFirstCreditDate (state, payload) {
    state.firstCreditDate = payload
  },
  setPPSCurrentAppId (state, payload) {
    state.ppsCurrentAppId = payload
  },
  setPPSLatestAppId (state, payload) {
    state.ppsLatestAppId = payload
    state.ppsCurrentAppId = payload
  },
  setPPSNextAdvanceNumber (state, payload) {
    state.ppsNextAdvanceNumber = payload + 1
  },
  setPPSSinglePSActionInterest (state, payload) {
    state.ppsSinglePSActionInterest = payload
  },
  setPPSLatestSlaveLoan (state, payload) {
    state.ppsLatestSlaveLoan = payload
  },
  setPPSFirstValidSlaveLoan (state, payload) {
    state.ppsFirstValidSlaveLoan = payload
  },
  setPPSFirstValidSlaveLoanId (state, payload) {
    state.ppsFirstValidSlaveLoanId = payload
  },
  setLoanHistoryData (state, payload) {
    state.loanHistoryData = payload
  },
  setSendEmailLoanId (state, payload) {
    state.sendEmailLoanID = payload
  }
}

export default {
  namespace: true,
  state,
  getters,
  actions,
  mutations
}
